import React from 'react'
import { useWatch } from 'react-hook-form'
import { FormField } from '../forms/FormField'
import { SelectField } from '../forms/SelectField'
import { GENDER_OPTIONS, YES_NO_OPTIONS } from './profileStepOptions'
import type { FnaFormValues } from '../../contracts/fnaFormSchema'

/**
 * Step 1: Personal information with conditional spouse and child fields.
 *
 * @returns JSX.Element The personal step
 */
export function PersonalStep(): JSX.Element {
  const withSpouse = useWatch<FnaFormValues, 'withSpouse'>({ name: 'withSpouse' })
  const children = useWatch<FnaFormValues, 'children'>({ name: 'children' })

  return (
    <>
      <h2>Personal Information</h2>
      <FormField<FnaFormValues> name="name" label="Name" placeholder="Enter your full name" autoComplete="name" />
      <FormField<FnaFormValues>
        name="age"
        label="Age"
        type="number"
        placeholder="Enter your age"
        inputMode="numeric"
      />
      <SelectField<FnaFormValues>
        name="gender"
        label="Gender"
        options={GENDER_OPTIONS}
        placeholder="Select gender"
      />
      <SelectField<FnaFormValues>
        name="withSpouse"
        label="Are you married or with a spouse?"
        options={YES_NO_OPTIONS}
      />
      {withSpouse === 'yes' && (
        <>
          <FormField<FnaFormValues> name="spouseName" label="Spouse's name" placeholder="Enter spouse's name" />
          <FormField<FnaFormValues>
            name="spouseAge"
            label="Spouse's age"
            type="number"
            placeholder="Enter spouse's age"
            inputMode="numeric"
          />
          <SelectField<FnaFormValues>
            name="spouseGender"
            label="Spouse's gender"
            options={GENDER_OPTIONS}
            placeholder="Select gender"
          />
        </>
      )}
      <SelectField<FnaFormValues>
        name="children"
        label="Do you have children?"
        options={YES_NO_OPTIONS}
      />
      {children === 'yes' && (
        <FormField<FnaFormValues>
          name="numChildren"
          label="Number of children"
          type="number"
          placeholder="0"
          inputMode="numeric"
        />
      )}
    </>
  )
}
